import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useTenant } from "../contexts/TenantContext";
import useSessionActivity from "../hooks/useSessionActivity";

const formatClock = (seconds) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

/**
 * Keeps an active session alive and, when someone has gone quiet for most of the idle timeout, asks if they are still
 * there before signing them out. Renders nothing the rest of the time.
 */
export default function SessionIdleWarning() {
  const { user, logout } = useTenant();
  const navigate = useNavigate();

  const signOut = React.useCallback(() => {
    logout();
    navigate("/login");
  }, [logout, navigate]);

  const { secondsLeft, stayActive } = useSessionActivity({ enabled: !!user, onIdleExpired: signOut });

  return (
    <Dialog open={secondsLeft !== null} aria-labelledby="idle-warning-title">
      <DialogTitle id="idle-warning-title">Still there?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          There has been no activity for a while, so you will be signed out in{" "}
          <b>{secondsLeft === null ? "" : formatClock(secondsLeft)}</b>. Choose Stay signed in to keep working.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={signOut}>Sign out</Button>
        <Button variant="contained" onClick={stayActive}>Stay signed in</Button>
      </DialogActions>
    </Dialog>
  );
}
